module.exports = __webpack_public_path__ + "assets/img/soldiers_5.6c911a0d.png";